__turbopack_context__.v({
  "modalOld": "modal-old-module-scss-module__GWCbza__modalOld",
  "modalOld__isActive": "modal-old-module-scss-module__GWCbza__modalOld__isActive",
  "modalOld_close": "modal-old-module-scss-module__GWCbza__modalOld_close",
  "modalOld_content": "modal-old-module-scss-module__GWCbza__modalOld_content",
});
